import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { MasterService } from '../../../base-classes/master-service';
import { Step, CreateStepRequest, UpdateStepRequest } from '../models';

@Injectable({
  providedIn: 'root'
})
export class StepsService extends MasterService<Step> {
  
  constructor(http: HttpClient) {
    const baseUrl = `${environment.apiUrl}/steps`;
    super(http, baseUrl);
  }

  /**
   * Get steps by scenario ID
   */
  getStepsByScenario(scenarioId: string): Observable<Step[]> {
    return this.http.get<Step[]>(`${this.baseUrl}/scenario/${scenarioId}`);
  }

  /**
   * Get step by ID
   */
  getStepById(id: string): Observable<Step> {
    return this.http.get<Step>(`${this.baseUrl}/${id}`);
  }

  /**
   * Create new step
   */
  createStep(stepData: any): Observable<Step> {
    return this.http.post<Step>(this.baseUrl, stepData);
  }


  saveBulkStep(payload: {
    scenarioId?: string;
    steps: any[];
    deleteOldSteps?: boolean;
    recordingId?: string;
  }): Observable<Step> {
    return this.http.post<Step>(`${this.baseUrl}/save-multiple-steps`, payload);
  }

  /**
   * Update existing step
   */
  updateStep(id: string, stepData: UpdateStepRequest): Observable<Step> {
    return this.http.put<Step>(`${this.baseUrl}/${id}`, stepData);
  }

  /**
   * Delete step (soft delete - sets isActive to false)
   */
  deleteStep(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  /**
   * Activate step
   */
  activateStep(id: string): Observable<Step> {
    return this.http.put<Step>(`${this.baseUrl}/${id}/activate`, {});
  }

  /**
   * Get steps by status (active/inactive)
   */
  getStepsByStatus(isActive: boolean): Observable<Step[]> {
    return this.http.get<Step[]>(`${this.baseUrl}/status/${isActive}`);
  }
}